import { createFileRoute } from '@tanstack/react-router'
import BoardLinkPage from '@/spa/pages/BoardLinkPage'
import { routeErrorComponent } from '../_shared/RouteError'

// Public: a subcontractor holding the capability URL has no account. Also
// listed in PUBLIC_PREFIXES (authGuard) and MARKETING_PREFIXES (route-gates),
// so the auth guard lets it through and the authed chrome stays off.
export const Route = createFileRoute('/board-link/$token')({
  component: BoardLinkPage,
  errorComponent: routeErrorComponent,
})
